import { ApplicationConfig } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { authInterceptor } from './auth/auth.interceptor';
import { provideIcons } from './icon/icon.provider';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideIcons,
    // Zero-padded day/month so e.g. German clients see "31.07.2026", not "31.7.2026".
    provideNativeDateAdapter({
      parse: {dateInput: null},
      display: {
        dateInput: {year: 'numeric', month: '2-digit', day: '2-digit'},
        monthYearLabel: {year: 'numeric', month: 'short'},
        dateA11yLabel: {year: 'numeric', month: 'long', day: 'numeric'},
        monthYearA11yLabel: {year: 'numeric', month: 'long'}
      }
    }),
    // Date/number formatting follows the client's own browser locale rather than a fixed build locale.
    {provide: MAT_DATE_LOCALE, useValue: navigator.language}
  ]
};
